import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../../../Header/Header";
import SideBar from "../../../SideBar/SideBar";
import "./addvancesearch.css";
import Footer from "../../../Footer/Footer";
import png11 from "../../../../assets/img/profiles/png 2.png";
import ProgramSearch from "../../Reusecomponent/ProgramSearch";
import { Switch } from "antd";
import { handelsearchapi } from "../../../HttpRequest/afterlogin";
import AddanceSearchresult from "../AddanceSearchresult";
import Country from "../Country";
import Pagination from "../../Base UI/Pagination";
import Loading from "../Loading";

const Addvancesearch = (props) => {
  const [pageInfo, setPageInfo] = useState({
    page: 0,
    size: 10,
  });
  // const { queryData } = props.location.state?.queryData || null;
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [userdata, setuserdata] = useState({
    studyLevel: "ALL",
    greScore: false,
    tofelScore: false,
    ieltsScore: false,
    pteScore: false,
    gmatScore: false,
    detScore: false,
    pteScore: false,
    applicationFee: false,
    scholarshipAvailable: false,
    maxYearlyTuitionFees: null,
    minYearlyTuitionFees: null
  });
  const [files, setfile] = useState(null);
  const [queryfiledinput, setqueryfiledinput] = useState("");

  const [idnumber, setidnumber] = useState(false);
  const [program, setprogram] = useState(false);
  const [apidata, setapidata] = useState([])
  const [searchbar, setsearchbar] = useState(true);
  const [searchbar0, setsearchbar0] = useState(false);
  const [cardselectbar, setcardselectbar] = useState(false);
  const [normalsearch, setnormalsearch] = useState(true);
  const [quicksearch, setquicksearch] = useState(true);
  const [loading, setLoading] = useState(false);

  const DataInfo = async () => {
    try {
      setLoading(true); 
      await new Promise((resolve) => setTimeout(resolve, 1000)); 
    } catch (error) {
      
    } finally {
      setLoading(false); 
      clearPagenation();
    }
  };

  const [api, setApi] = useState({
    apires: [],
    search: false
  })

  const updateUserData = (data) => {
    setuserdata({
      ...userdata,
      ...data
    })
  }

  // useEffect(() => {
  //   if (queryData !== null) {
  //     console.log("Addvancesearch", queryData);
  //     setuserdata({
  //       ...userdata,
  //       country: queryData.country,
  //       university: queryData.university,
  //       course: queryData.course,
  //       intake: queryData.intake,
  //       dataUpdated: true
  //     });
  //   }
  // }, [queryData]);

  const setPageInfoData = (data) => {
    console.log("page data to parent-->", data);
    setPageInfo({
      page: data.currentPage,
      size: data.pageSize,
    });
  };

  const clearPagenation = () => {
    setPageInfo({
      page: 0,
      size: 10,
    })
    handleclick()
  }
  const [pagedata, setPageData] = useState();

  useEffect(() => {
    if (pageInfo.page > 0) {
      handleclick();
    }
  }, [pageInfo]);

  const onChange = (checked, value) => {
    console.log(`switch to ${checked} ${value}`);
    if (value == "greScore") {
      console.log(value)
      setuserdata({
        ...userdata,
        greScore: !userdata.greScore
      })

    } if (value == "detScore") {
      console.log(value)
      setuserdata({
        ...userdata,
        detScore: !userdata.detScore
      })

    }
    if (value === "ieltsScore") {
      console.log(value)
      setuserdata({
        ...userdata,
        ieltsScore: !userdata.ieltsScore
      })
    }
    if (value === "tofelScore") {
      console.log(value)
      setuserdata({
        ...userdata,
        tofelScore: !userdata.tofelScore
      })
    }
    if (value == "applicationFee") {
      console.log(value)
      setuserdata({
        ...userdata,
        applicationFee: !userdata.applicationFee
      })
    }
    if (value === "scholarshipAvailable") {
      console.log(value)
      setuserdata({
        ...userdata,
        scholarshipAvailable: !userdata.scholarshipAvailable
      })
    } if (value == "gmatScore") {
      setuserdata({
        ...userdata,
        gmatScore: !userdata.gmatScore
      })
    }
    if (value === "pteScore") {
      console.log(value)
      setuserdata({
        ...userdata,
        pteScore: !userdata.pteScore
      })
    }
  };


  console.log(userdata);

  const handleWriteClick = async () => { };
  const handleChange = (event) => {
    const { name, value } = event.target;
    setqueryfiledinput({
      ...queryfiledinput,
      [name]: value,
    });
  };

  // const handleuniver = async () => {
  //   const concentration = "";
  //   console.log("searching-->", queryData);
  //   try {
  //     const response = await handelsearch(
  //       queryData.course,
  //       queryData.country,
  //       queryData.intake,
  //       queryData.university,
  //       pageInfo.page,
  //       pageInfo.size
  //     );
  //     console.log("search response api-->", response);
  //     setapidata(response.data);
  //     setPageData(response.data.metaData)
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   }
  // };
  const handlechan = (event) => {
    const { name, value } = event.target;
    setuserdata({
      ...userdata,
      [name]: value,
    });
    console.log('user data-->', userdata);
  }

  const handleclick = async () => {
    console.log("search api pagenation-->", pageInfo);
    const response = await handelsearchapi(userdata, pageInfo.page, pageInfo.size);
    if (response.status === 200 || response.status === 201) {
      if (response.data.data) {
        console.log("Advance search response ===>", response.data.metaData);
        setprogram(true);
        setapidata(response.data);
        setPageData(response.data.metaData);
      } else {
        console.log("data not found")
      }

    }
  }
  const imageSubmit = (event) => {
    const file = event.target.files[0];
    setfile(file);
  };

  const handleimageupload = async () => {
    const response = fileuploads(files);

    console.log("file", files);
    response.then((data) => {
      console.log(data);
      if (data.request.status == 200) {
        alert("success");
      } else {
        alert("error");
      }
    });
  };

  return (
    <>
      <div className="main-wrapper">
        {/* Header */}
        <Header />

        {/* Sidebar */}
        <SideBar />

        {/* Page Wrapper */}
        <div className="page-wrapper ">
          <div>
            <div className="imagespropety">
              <div className="pagecolum">
                <div className="card cardselectsearch_button cardselectbar">
                  <Link
                    to="/Normalsearch"
                    className={`cardselectsearch_buttonbg ${idnumber ? "idnumber" : null
                      }`}
                    onClick={() => {
                      setidnumber(true);
                      setsearchbar(false);
                      setsearchbar0(false);
                    }}
                  >
                    {" "}
                    <h6>Normal search</h6>
                  </Link>
                  <Link
                    to="/addvancesearch"
                    className={`cardselectsearch_buttonbg ${searchbar ? "searchbar" : null
                      }`}
                    onClick={() => {
                      setidnumber(false);
                      setsearchbar(true);
                      setsearchbar0(false);
                      // setquicksearch(true);
                      setnormalsearch(false);
                    }}
                  >
                    <h6>Advance Search </h6>
                  </Link>{" "}
                  {/* <Link to="/quicksearch">
                    {" "}
                    <div
                      className={`cardselectsearch_buttonbg ${searchbar0 ? "searchbar0" : null
                        }`}
                      onClick={() => {
                        setidnumber(false);
                        setsearchbar(true);
                        setsearchbar0(false);
                      }}
                    >
                      <h6>Quick Search </h6>
                    </div>
                  </Link> */}
                </div>

                {/* {quicksearch && (
                  <>
                    {" "}
                    <div className="card cardnormatserach">
                      <div className="card-body card-narmal ">
                        <div className="col1">
                          <Selectdrop
                            placeholder="Select Course"
                            className="cssfor"
                          />
                          <Selectdrop
                            placeholder="Select University"
                            className="cssfor"
                          />
                        </div>

                        <div className="col1">
                          <Selectdrop
                            placeholder="Select Country"
                            className="cssfor"
                          />
                          <Selectdrop
                            placeholder="Select Course"
                            className="cssfor"
                          />
                        </div>

                        <div className="col1">
                          <Selectdrop
                            placeholder="Select University"
                            className="cssfor"
                          />
                          <Selectdrop
                            placeholder="Select Country"
                            className="cssfor"
                          />
                        </div>
                        <div className="col1 center center1">
                          <div
                            className="cardsearch"
                            style={{
                              display: "flex",
                              alignContent: "center",
                              justifyContent: "center",
                            }}
                            onClick={() => {
                              setprogram(true);
                              setcardselectbar(true);
                            }}
                          >
                            <i className="fas fa-search"></i>
                            <h5 style={{ textAlign: "center" }}>ADD</h5>{" "}
                          </div>{" "}
                        </div>
                      </div>
                    </div>{" "}
                    {program && (
                      <>
                        {" "}
                        <div class="card cardprogram">
                          <div class="card-body cardprogrampadding">
                            <ProgramSearch />
                          </div>
                        </div>
                      </>
                    )}
                  </>
                )} */}
                <div class="card card1c">
                  <div className="card-body card-narmal">

                    <Country userdata={userdata} setuserdata={updateUserData} placeholder="Select Country" className="cssfor" inputfiled="country" />

                    {/* <University1 placeholder="Select University" className="cssfor" inputfiled="university" /> */}
                    {/* <Selectcourse placeholder="Select Course" className="cssfor" />
                    <Country placeholder="Select Country" className="cssfor" inputfiled="country" />
                    <IntakeEducation placeholder="Select Intake" className="cssfor" inputfiled="course" /> */}
                    {/* <div className="cardsearch" onClick={async () => { setprogram(true); setcardselectbar(true); clearPagenation(); }}>
                      <i className="fas fa-search"></i>
                      </div>        */}
                    <div onClick={async () => { setprogram(true); setcardselectbar(true); clearPagenation(); }}>
                    </div>

                  </div>
                  <hr></hr>
                  <div class="card-body">
                    <div className="row g-3 align-items-center just-space">
                      <div class="col-auto">
                        <label for="inputPassword6" class="col-form-label fw-bold">Study level</label>
                      </div>
                      <div class="col-auto  addvancesearchselect"  >
                        <select onChange={handlechan} style={{ width: '7rem' }}
                          name="studyLevel" value={userdata.studyLevel}  >
                          <option value="All">All</option>
                          <option value="Postgraduate">Postgraduate</option>
                          <option value="Undergraduate">Undergraduate</option>
                          <option value="PhD">PHD</option>
                          <option value="English">English[ESL,IEP,ELP]</option>
                        </select>
                      </div>
                      <div class="col-auto">
                        <label for="inputPassword6" class="col-form-label  fw-bold">Without GMAT</label>
                      </div>
                      <div class="col-auto  addvancesearchselect"  >
                        <Switch onChange={(checked) => onChange(checked, "gmatScore")} />
                      </div>
                      <div class="col-auto">
                        <label for="inputPassword6" class="col-form-label fw-bold">Without GRE</label>
                      </div>
                      <div class="col-auto  addvancesearchselect"  >
                        <Switch onChange={(checked) => onChange(checked, "greScore")} />
                      </div>
                    </div>


                    <br></br>
                    <div className="row g-3 align-items-center just-spacebet">
                      <div class="col-auto">
                        <label for="inputPassword6" class="col-form-label fw-bold">English proficiency </label>
                      </div>
                      <div class="col-auto  addvancesearchselect"  >
                        <div class="form-check">
                          <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" onChange={(event) => onChange(event.target.checked, "ieltsScore")} />
                          <label class="form-check-label">
                            IELTS
                          </label>
                        </div>
                      </div>
                      <div class="col-auto  addvancesearchselect"  >
                        <div class="form-check">
                          <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" onChange={(event) => onChange(event.target.checked, "tofelScore")} />
                          <label class="form-check-label">
                            TOFEL
                          </label>
                        </div>
                      </div>
                      <div class="col-auto  addvancesearchselect"  >
                        <div class="form-check">
                          <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" onChange={(event) => onChange(event.target.checked, "pteScore")} />
                          <label class="form-check-label">
                            PTE
                          </label>
                        </div>
                      </div>
                      <div class="col-auto  addvancesearchselect"  >
                        <div class="form-check">
                          <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" onChange={(event) => onChange(event.target.checked, "detScore")} />
                          <label class="form-check-label">
                            DET
                          </label>
                        </div>
                      </div>
                      {/* <div class="col-auto  addvancesearchselect"  >
  <div class="form-check">
  <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
  <label class="form-check-label" for="flexCheckDefault">
   DUOLINGO
  </label>
</div>
  </div> */}
                    </div>

                    <br></br>
                    <div className="row g-3 align-items-center just-spacebet">
                      <div class="col-auto d-flex">
                        <label for="inputPassword6" class="col-form-label fw-bold">Without Application Fee </label>
                        <div class="form-check">
                          <Switch onChange={(checked) => onChange(checked, "applicationFee")} />
                        </div>
                      </div>
                      <div class="col-auto  addvancesearchselect"  >

                      </div>
                      <div class="col-auto  d-flex"  >
                          <label class="form-check-label fw-bold" for="">
                            Scholarship Available  </label>
                          <div class="form-check">
                            <Switch onChange={(checked) => onChange(checked, "scholarshipAvailable")} />

                          </div>
                        </div>




                      <div class="col-auto  addvancesearchselect"  >

                      </div>

                    </div>

                    <br></br>
                    <div className="row g-3 align-items-center just-spacebet">
                      <div class="row g-3 align-items-center">

                        <div class="col-auto">
                          <label for="inputPassword6" class="col-form-label fw-bold">Annual Tuition Fees </label>
                        </div>
                        <div class="col-auto">
                          <label for="inputPassword6" class="col-form-label">Min</label>
                        </div>
                        <div class="col-auto ">
                          <input type="text" id="inputPassword6" class="form-control formmin" name="minYearlyTuitionFees" aria-describedby="passwordHelpInline" onChange={handlechan} />
                        </div>

                        <div class="col-auto">
                          <label for="inputPassword6" class="col-form-label">Min</label>
                        </div>
                        <div class="col-auto ">
                          <input type="text" id="inputPassword6" class="form-control formmin" name="maxYearlyTuitionFees" aria-describedby="passwordHelpInline" onChange={handlechan} />
                        </div><br></br>
                        {loading ? (
                    <Loading />
                  ) : (<button onClick={DataInfo} className="btn btn-primary" style={{ width: '5rem' }}>Search</button> )}
                      </div>

                    </div>
                  </div>
                </div>

                {program && <> <div class="card cardprogram">
                  <div class="card-body cardprogrampadding">
                    <ProgramSearch searchresult={apidata}/>
                  </div>
                </div>
                </>
                }
                {pagedata?.totalPages > 1 && (
                  <Pagination pageResponce={pagedata} pagedataToParent={setPageInfoData} />
                )}
                {api.search && <> <AddanceSearchresult data={api.apires} /></>}
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <Footer />
      </div>
      {/* /Main Wrapper */}
    </>
  );
};

export default Addvancesearch;
